const UNKNOWN_WORDS_SORT_BY = {
  APPEARANCE: { value: 'APPEARANCE', label: 'Appearance' },
  FOREIGN_WORDS: { value: 'FOREIGN_WORDS', label: 'Foreign words' },
  DISH_NAME: { value: 'DISH_NAME', label: 'Dish Name' },
  DISH_DESCRIPTION: { value: 'DISH_DESCRIPTION', label: 'Dish Description' },
  DISH_INGREDIENTS_TEXT: {
    value: 'DISH_INGREDIENTS_TEXT',
    label: 'Dish Ingredients Text',
  },
  MENU_TITLE_NAME: { value: 'MENU_TITLE_NAME', label: 'Menu Title Name' },
  MENU_TITLE_DESCRIPTION: {
    value: 'MENU_TITLE_DESCRIPTION',
    label: 'Menu Title Description',
  },
  UNKNOWN: { value: 'UNKNOWN', label: 'Unknown' },
  PREPARATION_METHOD: {
    value: 'PREPARATION_METHOD',
    label: 'Preparetion Method',
  },
  COMMON_ENGLISH_WORD: {
    value: 'COMMON_ENGLISH_WORD',
    label: 'Common English Word',
  },
  COMMON_FOREIGN_WORD: {
    value: 'COMMON_FOREIGN_WORD',
    label: 'Common Foreign Word',
  },
  WHOLE_DISH_NAME: { value: 'WHOLE_DISH_NAME', label: 'Whole Dish Name' },
  NAME: { value: 'NAME', label: 'Name' },
  NOT_RELEVANT: { value: 'NOT_RELEVANT', label: 'Not Relevant' },
  CONTEXT_DEPENDANT: { value: 'CONTEXT_DEPENDANT', label: 'Context dependant' },
  NEW_INGREDIENT: { value: 'NEW_INGREDIENT', label: 'New Ingredient' },
  EXISTING_INGREDIENT: {
    value: 'EXISTING_INGREDIENT',
    label: 'Existing Ingredient',
  },
  DIET_LABEL: { value: 'DIET_LABEL', label: 'Diet Label' },
  ALLERGEN_LABEL: { value: 'ALLERGEN_LABEL', label: 'Allergen Label' },
  BLOCKERS: { value: 'BLOCKERS', label: 'Blockers' },
}

export default UNKNOWN_WORDS_SORT_BY
